module.exports = __webpack_public_path__ + "static/media/recorte-1.c6b5ddd2.png";